import React, {Component} from 'react';
import {Button, Form, Grid, Header, Icon, Image, Modal, Popup, Segment,Divider,Message,Label} from 'semantic-ui-react';
import AddNewKey from './add_new_key';
import * as unavailable from "../../assets/photo_unavailable.jpg";
import ReportContainer from "../../containers/report_container";
import {uploadKeyDetails} from "../../data/report_api";
import 'react-dropzone-component/styles/filepicker.css';
import 'dropzone/dist/min/dropzone.min.css';
import * as keyPlaceholder from "../../assets/keysplaceholder.png";
import Loader from "../universal/loader";
import { DropzoneComponent } from 'react-dropzone-component';
import {uploadAdditionalImage,getAdditionalInspectionImages,deleteAdditionalImage} from "../../data/inspection_api";
import ImageUploadDropzone from './image_upload_dropzone';

const uuidv1 = require('uuid/v1');

class Keys extends Component {

    constructor(props) {
        super(props);
        this.state = {
            submit: false,
            showKeysSection: false,
            keyName: undefined,
            keyDescription: undefined,
            showEdit: undefined,
            showCoEdit: undefined,
            keyCount: undefined,
            imageFile: undefined,
            ciImageFile:undefined,
            inspectionType: undefined,
            ciImageEdit: undefined,
            coImageEdit: undefined,
            attachments: [],
            additional_images:[],
            loading:true,
            errorMsg:undefined,
            imgErrorMsg:undefined,
            failedUploads:[],
            failedAddUploads: []
        }
    }

    componentWillMount() {
        this.setState({
            showKeysSection: this.props.showKeys,
            inspectionType: this.props.reportDetails['inspection_type']
        })
        this.getAdditionalImages()
    }
    
    getAdditionalImages = async () => {
            const response = await getAdditionalInspectionImages(this.props.inspectionId)
            this.setState({ additional_images: response,loading:false })
        
    }


    updateKeysDetail = (keyDetail) => {
        if (!keyDetail.action) {
            keyDetail['action'] = 'update'
        }
        keyDetail['ci_description'] = this.state.keyName;
        keyDetail['co_description'] = this.state.keyName;
        this.props.updateKeyInReport(keyDetail);
    };

    updateKeysCount = (keyDetail) => {
        if (!keyDetail.action) {
            keyDetail['action'] = 'update'
        }
        if (this.props.other_template) {if (this.state.showEdit) {
                keyDetail['ci_no_of_keys'] = this.state.keyCount;
            }
            else
            {
                keyDetail['co_no_of_keys'] = this.state.keyCount;
            }
         }
        else {
            if (this.state.inspectionType !== 'co') {
                keyDetail['ci_no_of_keys'] = this.state.keyCount;
            }
            else {
                keyDetail['co_description'] = keyDetail['co_description'] ? keyDetail['co_description'] : keyDetail['ci_description'];
                keyDetail['co_no_of_keys'] = this.state.keyCount;
            }
        }
          if((keyDetail["ci_no_of_keys"] > keyDetail["co_no_of_keys"])& this.state.inspectionType == 'co'){
                window.alert("This key's CO quantity is less than its CI quantity, please remember to add this as a Teannt Cost on the Tenant Cost General Note")
            }
        this.props.updateKeyInReport(keyDetail);
    };

    retryImageUpload = async ()  =>{
        let images = [...this.state.failedUploads]
        let addImages = [...this.state.failedAddUploads]
        this.setState({isSaving:true,imgErrorMsg:undefined,failedUploads:[],failedAddUploads:[]})
        if (images.length > 0 || addImages.length > 0) {
            for (let i = 0; i < images.length; i++) {
            
                    await this.props.uploadImages(images[i], this.successFn);
                }
            for (let i = 0; i < addImages.length; i++) {
                let addResponse = undefined
                addResponse = await uploadAdditionalImage(addImages[i]);
                this.addSuccessFn(addResponse, addImages[i])
            }
            this.completeCallBack();
        
         } else {
            this.completeCallBack();
        }


    }

    deleteKey = (keyDetail) => {
        this.props.deleteKeyInReport(keyDetail)
    };

    uploadKeys = async () => {
        this.setState({isSaving:true,errorMsg:undefined});
        let reportUpdateKeys = this.props.updateKeys;
        setTimeout(async () => {
            if (this.state.imageFile) {
                reportUpdateKeys['images'] = {
                    id: this.state.imageFile.id
                }
            }
            if (this.state.ciImageFile) {
                reportUpdateKeys['ci_images'] = {
                    id: this.state.ciImageFile.id
                }
            }
            if (reportUpdateKeys.keys.length > 0 || this.state.imageFile || this.state.ciImageFile || this.state.attachments.length > 0) {
                this.setState({isSaving:true,errorMsg:undefined});
                let reportType = this.props.other_template? "both" : this.props.reportDetails['inspection_type'];
                const reportTypes = {"ci": "ci", "co": "co", "inv/ci": "ci", "inv": "ci","both":"both","sng":"ci"};
                await uploadKeyDetails(reportTypes[reportType], reportUpdateKeys).then(async (response) => {
                    if (response.success) {
                        if (this.state.imageFile) {
                            const formData = new FormData();
                            formData.append("id", this.state.imageFile.id);
                            formData.append("file", this.state.imageFile.file);
                            await this.props.uploadImages(formData, this.successFn);
                        }
                        if (this.state.ciImageFile) {
                            const formData = new FormData();
                            formData.append("id", this.state.ciImageFile.id);
                            formData.append("file", this.state.ciImageFile.file);
                            await this.props.uploadImages(formData, this.successFn);
                        }
                        
                        if(this.state.attachments) {
                            let addResponse = undefined
                            for (let i = 0; i < this.state.attachments.length; i++) {
                                if (this.state.attachments[i].status === "queued") {
                                const formData = new FormData();
                                formData.append("id", this.state.attachments[i].upload.uuid);
                                formData.append("file", this.state.attachments[i]);
                                formData.append("inspection_id",this.props.inspectionId);
                                formData.append("image_type","keys");
                                addResponse = await uploadAdditionalImage(formData);
                                this.addSuccessFn(addResponse, formData)
                            }
                                
                            }
                        }
                        this.completeCallBack(response,undefined)
                    }
                    else {
                        {this.setState({errorMsg:response.statusMessage || "There was an error while saving, please try again",isSaving:false})}
                    }
                }).catch((e)=>{
                    {this.setState({errorMsg:"There was an error while saving, please try again",isSaving:false})}
                });
            }
            else {
                this.props.handleClose();
            }
        }, 700);

    };

    successFn = (response, image) => {
        if (!response.success) {
            let error = undefined
            let err = response.statusMessage
            if (err.response) {
                error = err.response.data.error || "An error occurred on the server.";
            } else if (err.request) {
                error = "Network error: Please check your internet connection.";
            } else {
                error = err.message || "An unknown error occurred.";
            }
            this.setState({ imgErrorMsg:error, failedUploads:[...this.state.failedUploads, image]})
        }
    };
    addSuccessFn = (response, image) => {
        if (!response.success) {
            let error = undefined
            let err = response.error
            if (err.response) {
                error = err.response.data.error || "An error occurred on the server.";
            } else if (err.request) {
                error = "Network error: Please check your internet connection.";
            } else {
                error = err.message || "An unknown error occurred.";
            }
            this.setState({ imgErrorMsg:error, failedAddUploads:[...this.state.failedAddUploads, image]})
        }
    };

    exitWindow = () =>{
        this.props.resetDataQueuedInAPI('keys');
        this.setState({isSaving:false});
        this.props.handleClose();
    }

    completeCallBack = () => {
         if(this.state.failedUploads.length > 0 || this.state.failedAddUploads.length > 0) {
            this.setState({isSaving:false})
        } 
        else {
            this.exitWindow()
        }
    };

    updateKeyImage = (file) => {
        let editType = null
        editType = (this.state.coImageEdit ? "co" : "ci")
        let fr = new FileReader();
        if (file) {
            fr.onload = (e) => {
                file['dataURL'] = e.target.result;
                const image = {
                    id: uuidv1(),
                    file: file,
                    dataURL: e.target.result
                };
                if (!this.props.other_template) { this.setState({ imageFile: image }); }
                else {this.state.ciImageEdit ? this.setState({ ciImageFile: image }) : this.setState({ imageFile: image });}
                setTimeout(() => {
                    this.props.setKeyImage((this.props.other_template ? editType : this.state.inspectionType), image.id, image.dataURL)
                }, 1000);
            };
            fr.readAsDataURL(file);
        }
        setTimeout(() => {
            this.setState({ciImageEdit: undefined, coImageEdit: undefined});
        }, 1000);
    };
    preloadImages = (dropzone,imageData) => {
        if (imageData) {

            for (let i = 0; i < imageData.length; i++){
                if(imageData[i].image_type == "keys"){
            const name = imageData[i].id
            const file = {url: imageData[i].file?imageData[i].file:unavailable, name: name, size: 1000000, id: name};
            const imageUrl = imageData[i].file;

            file['serverId'] = name;
            file['accepted'] = true;
            file['status'] = 'success';
            file['upload'] = {
                progress: 100,
                total: 100000,
                bytesSent: 100000
            };
            dropzone.files.push(file);
            this.state.attachments.push(file)
            this.setState({preLoaded:true});
            dropzone.emit("addedfile", file);
            dropzone.emit("thumbnail", file, imageUrl);
                dropzone.emit("complete", file);
            }
        }
        }
    };

    removingFile = (file) => {
        let attachments = this.state.attachments;
        if (attachments.indexOf(file) !== -1) {
            attachments.splice(attachments.indexOf(file), 1);
        }
        if (file.id) { deleteAdditionalImage({image_id:file.id}) }
        return attachments;
    };
    render() {
        
        let dropZone = null;
        const componentConfig = {postUrl: 'no-url'};

        let djsConfig = {
            autoProcessQueue: false,
            addRemoveLinks: true,
            acceptedFiles: "image/jpeg, image/png, image/gif",
        };
        const eventHandlers = {
            init: (dropzone) => {
                dropZone = dropzone;
                dropZone.autoDiscover = false;
                this.preloadImages(dropzone, this.state.additional_images);
            },
            addedfile: (file) => {
                if(file.type.startsWith("image/")){
                  this.setState({attachments:[...this.state.attachments,file]})
                    this.setState({imageError:false})
                }
                else {
                    this.setState({imageError:true})
                }
            },

            removedfile: (file) => {
                this.removingFile(file)                   
            }
        };
        
       
        

        
        const reportKeys = this.props.reportDetails ? this.props.reportDetails.keys : [];
        const ciImages = this.props.reportDetails['ci_keys_image'];
        const coImages = this.props.reportDetails['co_keys_image'];
        const inspectionType = this.props.reportDetails['inspection_type'];

        return (<Segment>
            {this.state.isSaving && <Loader save={true}/>}
            <Modal size="large" open={this.state.showKeysSection} onClose={(e) => {
                this.uploadKeys();
            }}>
                <Modal.Content style={{minHeight: '500px', overflowY: 'scroll',margin:'auto'}}>
                    <Header floated="right"><Icon className="icon-button" name="save" onClick={(e) => {
                        this.uploadKeys();
                    }}/></Header>
                    <Modal.Description>
                        <div>
                            <Header size="large" textAlign='center'>
                                Keys
                            </Header>
                             {this.state.errorMsg && <Message>There was an error while saving key details, please try again.   {this.state.errorMsg} <hr/>  <Button compact onClick={this.uploadKeys}>Retry Save</Button> <Button compact onClick={this.exitWindow}>Exit Window</Button> </Message>}
                             {(this.state.failedUploads.length > 0 || this.state.failedAddUploads.length > 0 )&& <Message> {this.state.failedUploads.length + this.state.failedAddUploads.length} Image(s) failed to upload, try again? {this.state.imgErrorMsg}<hr/> <Button compact onClick={this.retryImageUpload}>Retry Upload</Button> <Button compact onClick={this.exitWindow}>Exit Window</Button> </Message>}
                        </div>
                        <Divider hidden/>
                        <Grid stackable>
                            <Grid.Row>
                            <Grid.Column width={8}>
                                <Header content="Check-In" color="teal" textAlign='center'/>
                                {(inspectionType !== 'co' || this.props.other_template) &&
                                <Icon name="image" size="large" className="pull-right icon-button" onClick={() => {
                                    (inspectionType !== 'co' || this.props.other_template) && this.setState({ciImageEdit: true, coImageEdit:false})
                                }}/>}
                                <div style={{minHeight: '200px'}}>
                                    {this.state.ciImageEdit && <ImageUploadDropzone  handlerFunction={(file) => {
                                        this.updateKeyImage(file)
                                    }}/>}
                                    <Image width="150px" height="150px"
                                           src={(ciImages && ciImages['image_path']) ? ciImages['image_path'] : ((this.state.imageFile && inspectionType !== 'co') ? this.state.imageFile.dataURL : ((ciImages && ciImages['dataURL']) ? ciImages['dataURL'] : keyPlaceholder))}
                                           rounded centered/>
                                </div>
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <Header content="Check-Out" color="teal" textAlign='center'/>
                                {inspectionType === 'co' &&
                                <Icon name="image" size="large" className="pull-right icon-button" onClick={() => {
                                    (inspectionType === 'co') && this.setState({coImageEdit: true, ciImageEdit:false})
                                }}/>}
                                <div style={{minHeight: '200px'}}>
                                    {this.state.coImageEdit && <ImageUploadDropzone  handlerFunction={(file) => {
                                        this.updateKeyImage(file)
                                    }}/>}
                                    <Image width="150px" height="150px"
                                           src={(coImages && coImages['image_path']) ? coImages['image_path'] : ((this.state.imageFile && inspectionType === 'co') ? this.state.imageFile.dataURL : ((coImages && coImages['dataURL']) ? coImages['dataURL'] : keyPlaceholder))}
                                           rounded centered/>
                                </div>
                            </Grid.Column>
                            </Grid.Row>
                            </Grid>
                        {reportKeys ? reportKeys.map((cKey, i) => {
                            return (<Segment key={cKey['client_id']}>
                                        <Grid centered style={{marginTop:"0px"}}stackable>
                                            <Grid.Row>
                                            <Grid.Column width={7}> 
                                                {this.state.showEdit === cKey['client_id'] &&
                                                <div className="ui input">
                                                    <Form onSubmit={() => {
                                                        this.updateKeysDetail(cKey)
                                                    }}>
                                                        <input style={{verticalAlign: 'middle'}} type="text"
                                                               defaultValue={cKey['ci_description']}
                                                               placeholder="Key Name"
                                                               onFocus={(e) => {
                                                                   this.setState({keyName: e.target.value})
                                                               }}
                                                               onChange={(e) => {
                                                                   this.setState({keyName: e.target.value})
                                                               }}
                                                               onBlur={() => {
                                                                   this.setState({showEdit: undefined});
                                                                   this.updateKeysDetail(cKey);
                                                               }}
                                                               required
                                                        />
                                                    </Form>
                                                </div>
                                                }
                                                {this.state.showEdit !== cKey['client_id'] &&

                                                 <Button as='div' style={{width:"100%"}} labelPosition='left' onClick={(e) => {
                                                    if (inspectionType !== 'co' || (inspectionType === 'co' && this.props.other_template)) {
                                                        this.setState({showEdit: cKey['client_id']})
                                                    }
                                                }}><Label>Name</Label> <Button style={{width:"100%"}} basic>{cKey['ci_description'] ? cKey['ci_description'] :"NA"}</Button></Button>}
                                            </Grid.Column>
                                            <Grid.Column width={4}> 
                                                {this.state.showEdit === cKey['client_id'] &&
                                                <div className="ui input">
                                                    <Form onSubmit={() => {
                                                        this.updateKeysCount(cKey)
                                                    }}>
                                                        <input type="number" style={{ verticalAlign: 'middle' }}
                                                               defaultValue={cKey['ci_no_of_keys']}
                                                               placeholder="Key Count"
                                                               onFocus={(e) => {
                                                                   this.setState({keyCount: e.target.value})
                                                               }}
                                                               onChange={(e) => {
                                                                   this.setState({keyCount: e.target.value})
                                                               }}
                                                               onBlur={() => {
                                                                   this.setState({showEdit: undefined});
                                                                   this.updateKeysCount(cKey);
                                                               }}
                                                               required
                                                        />
                                                    </Form>
                                                </div>
                                                }
                                                {this.state.showEdit !== cKey['client_id'] &&
                                                 <Button as='div'  style={{width:"100%"}} labelPosition='left' onClick={(e) => {
                                                    if (inspectionType !== 'co' || this.props.other_template) {
                                                        this.setState({showEdit: cKey['client_id']})
                                                    }
                                                }}><Label > CI # of Keys</Label> <Button basic>{cKey['ci_no_of_keys'] ? cKey['ci_no_of_keys'] : "0"}</Button></Button>
                                            }</Grid.Column>
                                                {inspectionType == "co" && <Grid.Column width={4}> 
                                                    {this.state.showCoEdit === cKey['client_id'] &&
                                            <div className="ui input">
                                                <Form onSubmit={() => {
                                                    this.updateKeysCount(cKey)
                                                }}>
                                                    <input type="number"style={{ verticalAlign: 'middle' }}
                                                           defaultValue={cKey['co_no_of_keys']}
                                                           placeholder="Key Count"
                                                           onFocus={(e) => {
                                                               this.setState({keyCount: e.target.value})
                                                           }}
                                                           onChange={(e) => {
                                                               this.setState({keyCount: e.target.value})
                                                           }}
                                                           onBlur={() => {
                                                               this.setState({showCoEdit: undefined});
                                                               this.updateKeysCount(cKey);
                                                           }}
                                                           required
                                                    />
                                                </Form>
                                            </div>
                                            }
                                            {this.state.showCoEdit !== cKey['client_id'] && inspectionType == "co" &&
                                            <Button as='div' labelPosition='left' onClick={(e) => {
                                                    if (inspectionType == 'co') {
                                                        this.setState({showCoEdit: cKey['client_id']})
                                                    }
                                                }}><Label> CO # of Keys</Label> <Button basic>{cKey['co_no_of_keys'] ? cKey['co_no_of_keys'] : "0"}</Button></Button>
                                              
                                            }
                                            </Grid.Column>}
                                            <Grid.Column width={1}> 
                                               <div  style={{textAlign:"center"}}> <Popup
                                                    trigger={<Button disabled={inspectionType=="co" && !this.props.other_template && cKey["ci_no_of_keys"] > 0}color="red" icon><Icon size="large" name="trash"
                                                                   className="icon-button"/></Button>}
                                                    content={<Button negative content="Confirm Delete?"
                                                                     onClick={() => {
                                                                         this.deleteKey(cKey)
                                                     
                                                                        }}/>}
                                                    on="click"
                                                    position="left center"
                                                    hideOnScroll
                                                /></div>
                                            </Grid.Column>
                                    </Grid.Row></Grid>
                                    </Segment>
                            )
                        }): <Message> No Key Details Available</Message>}
                            {reportKeys && reportKeys.some((k) => {return k["ci_no_of_keys"] > k["co_no_of_keys"]}) && <Message>Some Check Out keys have lower quantities than their Check In amounts, please add any missing keys as a Tenant Cost General Note (Flag Icon)</Message>}

                        <AddNewKey/>
                        <Header>Additional Key Photos</Header>                        
                        {!this.state.loading &&<DropzoneComponent config={componentConfig} style={{ minHeight: 250 }}
                eventHandlers={eventHandlers} djsConfig={djsConfig}/>}
                    </Modal.Description>
                </Modal.Content>
            </Modal>
        </Segment>)
    }
}

export default ReportContainer(Keys);


// WEBPACK FOOTER //
// ./src/views/report/keys.js